import type { JSX } from 'react'

import { GeoblockErrorScreenTemplate } from "/app/libraries/arcana/src/blocks/GeoblockErrorScreen/Templates/index.ts"

import { useUnit } from 'effector-react'
import { model as i18n } from '~/core/i18n'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout } from '~/widgets/auth'

export function Title(): JSX.Element {
  return <AppTitle t='geoblock' />
}

GeoBlockPage.displayName = 'GeoBlockPage'
export function GeoBlockPage(): JSX.Element {
  const { t } = useUnit(i18n.$t)

  return (
    <AuthLayout>
      <GeoblockErrorScreenTemplate
        title={t('sorry')}
        description={t('geo_block_log_in_error')}
      />
    </AuthLayout>
  )
}
